
import Component from '../../../assets/scripts/modules/component'

class FormContainerComponent extends Component {
  init () {
    this.error = this.element.querySelector('.text-field--error, .option-field--error, .dropdown-field--error')

    if (this.error) {
      this.error.scrollIntoView()
    }
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.form-container').forEach(element => {
  element.instance = element.instance || new FormContainerComponent(element)
}))
